export default () => ({
  trigger: {
    name: 'active_mailer.unsubscribe',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'active_mailer_overlay',
        content: 'unsubscribe',
      },
    },
  },
});
